import { render, staticRenderFns } from "./CarSPUAudit.vue?vue&type=template&id=0b7a647a&scoped=true"
import script from "./CarSPUAudit.vue?vue&type=script&lang=ts"
export * from "./CarSPUAudit.vue?vue&type=script&lang=ts"
import style0 from "./CarSPUAudit.vue?vue&type=style&index=0&id=0b7a647a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7a647a",
  null
  
)

export default component.exports